import $ from 'jquery';
import { games } from './games.json';

const search = (function() {
  var ret = {};
  var seg = window.location.search.replace(/^\?/, '').split('&').filter(function(v,i){
      if (v!==''&&v.indexOf('=')) {
          return true;
      }
  });
  seg.forEach( function(element, index) {
      var idx = element.indexOf('=');
      var key = element.substring(0, idx);
      var val = element.substring(idx+1);
      ret[key] = val;
  });
  return ret;
})()

if (search.id) {
  renderIframe(search.id);
  fillData(search.id);
}

function renderIframe(id) {
  const iframe = $(`<iframe frameborder="0" src="/gamelist/${id}/index.html"></iframe>`);

  $('#game_wrp').append(iframe);

  window.addEventListener("load", function() {

    $('.loader-title-btn, .loader-footer-btn').text('PLAY NOW!');
    $('.loader-title-btn, .loader-footer-btn').on('click', () => {
      $('#loaderMask').hide();
      $('#game_wrp').show();
      (adsbygoogle = window.adsbygoogle || []).push({});
    });

  }, false);

  // ç¸('DOMContentLoade∑zdfevdaqzzd', () => {
  //   $('.loader-title-btn, .loader-footer-btn').text('PLAY NOW!');
  //   $('.loader-title-btn, .loader-footer-btn').on('click', () => {
  //     $('#loaderMask').hide();
  //     $('#game_wrp').show();
  //     (adsbygoogle = window.adsbygoogle || []).push({});
  //   });
  // })
}

function fillData(id) {
  const item = games.find(item => item.id == id)
  $('.loader-banner').css('backgroundImage', `url(gamelist/${item.id}/banner_t.jpg)`);
  $('.loader-title-h1').text(item.title);
  $('#loaderInfo div').text(item.description);
}

function showShare () {
  $('.fullscreen').show();
  // $('.fullscreen-body > div').empty().html(`<ins class="adsbygoogle"
  // style="display:inline-block;width:320px;height:250px"
  // data-ad-client="ca-pub-1002463960821147"
  // data-ad-slot="5362268399"></ins>`);

  // (adsbygoogle = window.adsbygoogle || []).push({});

  $('.fullscreen-close-btn').hide();
  let time = 3;
  $('.fullscreen-time-btn').show().text(time);
  const interval = setInterval(() => {
    time -= 1;
    $('.fullscreen-time-btn').text(time);
    if (time === 0) {
      clearInterval(interval);
      $('.fullscreen-time-btn').hide();
      $('.fullscreen-close-btn').show();
    }
  }, 1000);

  $('.fullscreen-close-btn').one('click', () => {
    $('.fullscreen').hide();
  })  
}

$('body').height($(window).height())

window.showShare = showShare;